<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 16.5C9 18.1569 10.3431 19.5 12 19.5C13.6569 19.5 15 18.1569 15 16.5C15 14.8431 13.6569 13.5 12 13.5C10.3431 13.5 9 14.8431 9 16.5ZM11 16.5C11 15.9477 11.4477 15.5 12 15.5C12.5523 15.5 13 15.9477 13 16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5Z"
      fill="#01ED03"
    />
    <path
      d="M17 17.5C16.4477 17.5 16 17.0523 16 16.5C16 14.2909 14.2091 12.5 12 12.5C9.79086 12.5 8 14.2909 8 16.5C8 17.0523 7.55228 17.5 7 17.5C6.44772 17.5 6 17.0523 6 16.5C6 13.1863 8.68629 10.5 12 10.5C15.3137 10.5 18 13.1863 18 16.5C18 16.7652 17.8946 17.0196 17.7071 17.2071C17.5196 17.3946 17.2652 17.5 17 17.5Z"
      fill="#01ED03"
    />
    <path
      d="M20 17.5C19.4477 17.5 19 17.0523 19 16.5C19 12.634 15.866 9.5 12 9.5C8.13401 9.5 5 12.634 5 16.5C5 17.0523 4.55228 17.5 4 17.5C3.44772 17.5 3 17.0523 3 16.5C3 11.5294 7.02944 7.5 12 7.5C16.9706 7.5 21 11.5294 21 16.5C21 16.7652 20.8946 17.0196 20.7071 17.2071C20.5196 17.3946 20.2652 17.5 20 17.5Z"
      fill="#01ED03"
    />
    <path
      d="M23 17.5C22.4477 17.5 22 17.0523 22 16.5C22 10.9772 17.5228 6.5 12 6.5C6.47715 6.5 2 10.9772 2 16.5C2 17.0523 1.55228 17.5 1 17.5C0.447715 17.5 0 17.0523 0 16.5C9.87562e-08 9.87258 5.37258 4.5 12 4.5C18.6274 4.5 24 9.87258 24 16.5C24 17.0523 23.5523 17.5 23 17.5Z"
      fill="#01ED03"
    />
  </svg>
</template>

<style lang="scss">
.va-icon-free {
  display: inline-block;
  width: 55px;
  height: 47.8px;

  .cls-1 {
    fill: #4ae387;
  }

  .cls-2 {
    fill: none;
    stroke: #34495e;
    stroke-miterlimit: 10;
    stroke-width: 3px;
  }

  .cls-3 {
    fill: #34495e;
  }
}
</style>
